// Fixed chart content height (Figma node 5676:1955) — keeps every insights card's
// chart slot the same vertical size whether it's loading, empty, or populated.
export const DEFAULT_CHART_HEIGHT = 240
